const STORAGE_PREFIX = 'chatbot-discovery-icons-local:';

function storageKey(bucketKey) {
  return `${STORAGE_PREFIX}${bucketKey || 'unknown'}`;
}

function safeJsonParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function normalizeLabel(label) {
  if (typeof label !== 'string') return 'icon';
  const s = label.trim();
  return s || 'icon';
}

function normalizeFileName(fileName, fallbackLabel) {
  if (typeof fileName === 'string' && fileName.trim()) {
    return fileName.trim().replace(/\.svg$/i, '');
  }
  return normalizeLabel(fallbackLabel);
}

function normalizeIconList(entry) {
  const icons = entry?.icons;
  if (!Array.isArray(icons)) return [];

  const out = [];
  const seenUrl = new Set();
  icons.forEach((item) => {
    if (!item || typeof item !== 'object') return;
    const url = item.url || item.dataUrl;
    if (typeof url !== 'string' || !url) return;
    if (seenUrl.has(url)) return;
    seenUrl.add(url);

    const id =
      typeof item.id === 'string' && item.id.trim()
        ? item.id.trim()
        : `local-${Date.now()}-${Math.random().toString(16).slice(2)}`;

    const label = normalizeLabel(item.label || id);
    out.push({
      id,
      url,
      label,
      fileName: normalizeFileName(item.fileName, label),
      source: 'local',
    });
  });

  return out;
}

export function loadLocalDiscoveryIcons(bucketKey) {
  if (typeof localStorage === 'undefined') {
    return [];
  }

  const key = storageKey(bucketKey);
  const raw = localStorage.getItem(key);
  if (!raw) return [];

  const entry = safeJsonParse(raw);
  if (!entry || typeof entry !== 'object') {
    localStorage.removeItem(key);
    return [];
  }

  return normalizeIconList(entry);
}

export function saveLocalDiscoveryIcon(bucketKey, { url, label, fileName }) {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  const key = storageKey(bucketKey);
  const current = loadLocalDiscoveryIcons(bucketKey);

  const nextId = `local-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const nextLabel = normalizeLabel(label || nextId);
  const nextIcon = {
    id: nextId,
    url,
    label: nextLabel,
    fileName: normalizeFileName(fileName, nextLabel),
    source: 'local',
  };

  const nextEntry = {
    icons: [...current, nextIcon].map(({ id, url, label, fileName: iconFileName }) => ({
      id,
      url,
      label,
      fileName: iconFileName,
    })),
    savedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(key, JSON.stringify(nextEntry));
    return nextIcon;
  } catch {
    return null;
  }
}

export function removeLocalDiscoveryIcon(bucketKey, id) {
  if (typeof localStorage === 'undefined') {
    return;
  }

  const key = storageKey(bucketKey);
  const current = loadLocalDiscoveryIcons(bucketKey);
  const next = current.filter((icon) => icon.id !== id);

  if (next.length === 0) {
    localStorage.removeItem(key);
    return;
  }

  const nextEntry = {
    icons: next.map(({ id, url, label, fileName }) => ({ id, url, label, fileName })),
    savedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(key, JSON.stringify(nextEntry));
  } catch {
    // ignore quota/storage errors
  }
}

